module.exports = __webpack_public_path__ + "static/media/SNX-BNB.b9a5f43c.svg";